import { Error as APIError } from '../models/index';

export const isAPIError = (input: Record<string, unknown> | undefined): input is APIError => {
  if (input === undefined) return false;
  if (input.code === undefined || input.message === undefined || input.name === undefined) return false;
  return true;
};
